'use strict';

import React from 'react';
import { Link } from 'react-router';
import store from 'store';
import flux from 'utils/flux';
import imgAsync from 'img-async';
import fallbackConfig from "../../fallbackConfig";

var MediaSlideshow = React.createClass({

    displayName: 'MediaSlideshow',

    propTypes: {
        slides: React.PropTypes.array.isRequired
    },

    getInitialState() {
        return {
            activeSlideIndex: 0,
            play: true
        }
    },

    componentDidMount() {
        var slides = this.props.slides;
        var len = slides.length;

        if ( len === 0 ) {
            return;
        }

        var inner = this.refs.inner.getDOMNode();

        inner.style.width = ( len * 100 ) + '%';
        Array.prototype.map.call( inner.childNodes, slide => { slide.style.width = ( 100 / len ) + '%' });

        this._goto( this.state.activeSlideIndex );
    },

    componentDidUpdate() {
        clearTimeout( this._timeout );

        if ( this.state.play ) {
            this._timeout = setTimeout(()=>{
                this._next();
            }.bind(this), 8000);
        }
    },

    componentWillUnmount() {
        clearTimeout( this._timeout );
    },

    _goto(ix) {
        if ( ix >= this.props.slides.length ) {
            ix = 0;
        }
        else if ( ix < 0 ) {
            ix = this.props.slides.length - 1;
        }
        this.setState({activeSlideIndex: ix});
    },

    _next() {
        this._goto( ++this.state.activeSlideIndex );
    },

    _previous() {
        this._goto( --this.state.activeSlideIndex );
    },

    _play() {
        this.setState({play: true});
    },

    _pause() {
        this.setState({play: false});
    },

    renderControls() {
        var slides = this.props.slides;
        if ( slides.length === 0 ) {
            return false;
        }
        return (
            <div className="landing-slideshow__controls">
                <ul className="landing-slideshow__pills">
                {slides.map(( slide, ix )=>{
                    return (
                        <li key={'slide_link_'+ix}><a href="#" onClick={(e)=>{
                            e.preventDefault();
                            this._pause();
                            this._goto(ix);
                        }} className={this.state.activeSlideIndex === ix ? 'active' : null}>{''}</a></li>
                    );
                })}
                </ul>
                <button className="landing-slideshow__prev" onClick={this._previous}><i className="chevron-left" /></button>
                <button className="landing-slideshow__next" onClick={this._next}><i className="chevron-right" /></button>
            </div>
        );
    },

    render() {
        var items = this.props.slides;
        var len = items.length;
        var left = 0;

        if ( len === 0 ) {
            return false;
        }

        left = ( -100 * this.state.activeSlideIndex ) + '%';

        let slides = items.map( (slide, ix) => {
          if (slide.type == 'url') {
              return (
                  <a key={'slide_'+ix} href={slide.href} className="landing-slideshow__slide" style={{backgroundImage: 'url('+slide.image+')'}} activeClassName="" target="_blank">
                      <div className="landing-slideshow__slide-copy">
                          <div className="landing-slideshow__slide-title">{slide.title}</div>
                          <div className="landing-slideshow__slide-subtitle">
                              {slide.subtitle}
                              {(!!slide.subtitle) ?
                                  <span className="play-icon"/>
                              : ''
                              }
                          </div>
                      </div>
                  </a>
              );
          } else {
              const { defaultPerPageResults } = flux.getStore('app').getState().config.toJS();
              let defaultAmountResult = Number.isInteger(defaultPerPageResults) ? defaultPerPageResults : fallbackConfig.defaultPerPageResults;
              let slideQuery = { search_id: slide.searchId, per_page: store.get('pagination_amount') ? store.get('pagination_amount') : defaultAmountResult };
              return (
                  <Link key={'slide_'+ix} to="listing" query={slideQuery} className="landing-slideshow__slide" style={{backgroundImage: 'url('+slide.image+')'}} activeClassName="">
                      <div className="landing-slideshow__slide-copy">
                          <div className="landing-slideshow__slide-title">{slide.title}</div>
                          <div className="landing-slideshow__slide-subtitle">
                              {slide.subtitle}
                              {(!!slide.subtitle) ?
                                  <span className="play-icon"/>
                              : ''
                              }
                          </div>
                      </div>
                  </Link>
              );
          };
        } );



        return (
            <div className="landing-slideshow">
                <div className="landing-slideshow__inner-clip">
                    <div className="landing-slideshow__inner" ref="inner" style={{left: left}}>
                        {slides}
                    })}
                    </div>
                </div>
                {this.renderControls()}
            </div>
        );
    }
});

module.exports = MediaSlideshow;



// WEBPACK FOOTER //
// ./app/pages/media/mediaSlideshow.jsx